import { z } from 'zod';

export const LoginValidator = z.object({
  email: z
    .string()
    .email({
      message: 'Please enter a valid email address.',
    })
    .min(1, {
      message: 'Please enter email.',
    }),
  password: z.string().min(1, {
    message: 'Please enter password.',
  }),
});

export type LoginFormData = z.infer<typeof LoginValidator>;
